import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Button
} from "reactstrap";
import {
  Link
} from "react-router-dom";


import ConnectorService from '../../services/api/Connector';
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import { Scrollbars } from 'react-custom-scrollbars';
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Element from 'components/Element.js';
import { FormContext } from '../Connectors/FormContext';
import { uuidv4 } from '../../components/Notebook/operations/notebook';
import Switch from "react-bootstrap-switch";
import { toast } from 'react-toastify';
import { newNotebookSample } from "settings/shared/constants_prod";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import axios from "axios";
import Item from "antd/lib/list/Item";
import { CONNECTOR_BASE_URL } from "settings/shared/constants";
const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}

class ShowConnector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connectorName : '',
      connectorConfig: [],
      groupvalue:[],
      newconnectorname:'',
      connectordescription: '',
      enableConnector: true,
      errorSubmitted: false,
      codeSnippet:[]
    }
  }
  componentDidMount() {
    this.getConnectors();
  }

  closeConnector = () => {
    this.props.history.push({
      pathname: '/integration/CreateConnection/',
    })
  }

  getConnectors = () => {
    axios.get(CONNECTOR_BASE_URL + this.props.location.state.config_path)
      .then(res => {
        this.setState({
          connectorName : res.data.name,
          codeSnippet: res.data    
        })
        var groupfields = []
        res.data.config.map((item, index) => {
          
          groupfields.push({
                  name: item.name,
                  type: item.type,
                  required: item.required,
                  secret: item.secret,
                  fieldValue: "", 
                  placeholder: this.createPlaceholder(item.name)
                })
        })

        this.setState({
          groupvalue : [...groupfields]
        })

      })
  }

createPlaceholder = (str) => {
  let text = str.match(/[A-Z | a-z][a-z]+|[0-9]+/g).join(" ");  
  return text.toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

  handleSwitchEnableConnector(elem, state) {
    this.setState({enableConnector:state})
  }

  closeConnector = () => {
    this.props.history.push({
      pathname: '/integration/CreateConnection/',
    })
  }

  // Submit New Connection Data
 
  handleSubmit = (event) => {
    event.preventDefault();
    let isSubmitEligible = true;
    
    if(this.state.newconnectorname === "" || this.state.newconnectorname === undefined) {
      this.setErrorMessage("Please enter the name field");
      isSubmitEligible = false;
    } else {
      this.state.groupvalue.forEach((field, index) => {
        if(field.required === true) {
          if(field.fieldValue === "" || field.fieldValue === undefined) {
            this.setErrorMessage("Please Fill Required Fields");
            isSubmitEligible = false;
          }
        }       

        if(field.type === "json") {
          try {
            var json = JSON.parse(field.fieldValue);
            return true;
          } catch (error) {
            this.setErrorMessage(field.name + " Not a valid JSON");
            isSubmitEligible = false;
          }
          
        } else {
          if(field.type === "integer") {
            if(isNaN(field.fieldValue)) {
            this.setErrorMessage( field.name + " is not a Integer value");
            isSubmitEligible = false;
            }
          }
        }
      })
    }   
   
    if(isSubmitEligible) {
      let post = {
        description: this.state.connectordescription,
        enable: this.state.enableConnector,
        connectorConfig: this.state.groupvalue,
        name: this.state.newconnectorname,
        connectorType: this.props.location.state.connectorName,
        version: "",
        category: this.getCategory(this.props.location.state.connectorCategory),
        connectorName: this.props.location.state.connName
      }
      this.setState({
        errorSubmitted: false
      })
      this.postConnector(post)
    }   
  }

  getCategory = (category) => {
    if (category == "all") {
      return this.props.location.state.allConnPath.split("/")[0]
    } else {
      return this.props.location.state.connectorCategory
    }
  } 

  postConnector = (post) => {
    this.setErrorMessage("");  
          ConnectorService.PostConnector(post)
          .then((response) => {
              if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Created Successfully!</b></i>); 
              this.props.history.push('/integration/connectors/');    
              // this.clearformData();   // Reset Form data    
              } else {
                toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
              }
          });
  }


  handleChange = (id, event) => {
    var newElements = [];
    this.state.groupvalue.forEach((field, index) => {
      const { name, type } = field;
      if (id === name) {
        switch (type) {
          case 'checkbox':
            field['fieldValue'] = event.target.checked;
            break;

            case 'boolean':
              field['fieldValue'] = event;
              break;  

          default:
            field['fieldValue'] = event.target.value;
            break;
        }
        this.setState({
          groupvalue: [
             ...this.state.groupvalue.slice(0,index),
             Object.assign({}, this.state.groupvalue[index], field),
             ...this.state.groupvalue.slice(index+1)
          ]
        });
      }
    });

  }

  handlefixedChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });

  }

  getConnnectorIcon = (icon_path) => {
    return CONNECTOR_BASE_URL + icon_path
    }

     //Setting Error
  setErrorMessage(message) {
    if (message === "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }


  render() {
    return (
      <>
        <PanelHeader
          content={
            <div className="header text-center">
            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            
            <Row>
              <div className=" col" id="errorDiv">

                <Col xs={12} md={12}>
                  <Card>
                    <CardHeader>
                      <Row className="align-items-center">
                        <div className="col">
                          <CardTitle tag="h5"> <img src={this.getConnnectorIcon(this.props.location.state.iconpath)} alt="Connector Image" style={{ height: '25px' }} />
                            &nbsp;{this.props.location.state.connectorName}</CardTitle>
                        </div>
                        <div className="col text-right">
                          <div onClick={this.closeConnector} style={{ cursor: 'pointer' }}>
                            <span className="close clear-filter">×</span>
                          </div>
                        </div>
                      </Row>
                    </CardHeader>
                    <Scrollbars autoHeight autoHeightMin={650} autoHeightMax={650}>
                      <CardBody className="cardHeight">
                        <div className="carcontent">
                          <Row className="mt-12">
                            <Col className="mb-12 mb-xl-0" xl="12">
                              <FormContext.Provider value={{
                                state: this.state,
                                handleSubmit: this.handleSubmit,
                                handleChange: this.handleChange
                              }}
                              >
                                <Card className="card-contributions ">
                                  <CardBody>
                                    <form>
                                      {this.state.errorSubmitted &&
                                        <div style={styles.errorBox}>
                                          <span style={styles.error}>{this.state.errorMessage}</span>
                                        </div>
                                      }
                                      <div style={{ backgroundColor: '#eee' }}>
                                        <code><b>Connection Details</b></code>
                                        <hr></hr>
                                      </div>

                                      <div>
                                            <Row>
                                          <Col md="4">
                                            <Label md="6">Name *</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Name"
                                                name="newconnectorname"
                                                id="newconnectorname"
                                                value={this.state.newconnectorname}
                                                type="text"
                                                onChange={this.handlefixedChange}
                                              />
                                            </FormGroup>
                                          </Col>
                                          <Col md="4">
                                            <Label md="6">Description</Label>
                                            <FormGroup>
                                              <Input
                                                className="form-control"
                                                placeholder="Description"
                                                name="connectordescription"
                                                id="connectordescription"
                                                // value={ConnDescription}
                                                value={this.state.connectordescription}
                                                type="text"
                                                onChange={this.handlefixedChange}
                                              />
                                            </FormGroup>
                                          </Col>
                                          {/* <Col md="4">
                                            <Label md="6">Type </Label>
                                            <FormGroup>
                                              <img src={`data:image/jpeg;base64,${this.state.iconimg}`} alt="Connector Image" style={{ height: '50px' }} />
                                            </FormGroup>
                                          </Col> */}
                                        </Row>

                                        {this.state.editId !== "" && <Row>
                                          <Col md="6">
                                            <FormGroup style={{ marginLeft: 14 }}>
                                              {/* <Switch defaultValue={false}/> <Switch /> */}
                                              <Label>Enable Connector </Label>&nbsp; &nbsp;&nbsp; &nbsp;<Switch onChange={(el, state) => this.handleSwitchEnableConnector(el, state)} value={this.state.enableConnector} name='enbale connector' data-on-color="secondary" data-off-color="default" />

                                            </FormGroup>
                                          </Col>

                                        </Row>}
                                        <br></br>
                                      </div>
                                      <Row className="icon-examples">

                                      {this.state.groupvalue.map((item, index) => {
                                        return (
                                          <Col md={4} id={uuidv4()} >
                                            <Element key={index} field={item} />
                                          </Col>
                                        )
                                        })}
                                      </Row>
                                      <Row className="stickybuttons">
                                        <button type="submit" className="btn btn-primary" onClick={(e) => this.handleSubmit(e)}>Save</button>
                                      </Row>
                                    </form>
                                  </CardBody>
                                </Card>
                              </FormContext.Provider>
                            </Col>
                          </Row>
                        </div>
                      </CardBody>
                    </Scrollbars>
                  </Card>
                </Col>
              </div>
            </Row>
            </LoadingOverlay>
          </div>
        </>
    );
  }
}

export default ShowConnector;

